import MapasPage from './mapasPage'

export default MapasPage